import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { Target, Zap, Palette, Users } from "lucide-react";

const DifferentialsSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  const items = [
    { icon: Target, title: "Pensadas para anúncios", desc: "Páginas otimizadas para campanhas de tráfego pago." },
    { icon: Zap, title: "Entrega extremamente rápida", desc: "Sua página pronta em até 72 horas." },
    { icon: Palette, title: "Design profissional", desc: "Visual moderno que transmite credibilidade." },
    { icon: Users, title: "Foco em geração de leads", desc: "Cada elemento pensado para converter visitantes em clientes." },
  ];

  return (
    <section className="py-24 md:py-32" ref={ref}>
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          className="text-center mb-16"
        >
          <span className="text-sm font-mono text-secondary uppercase tracking-widest">Diferenciais</span>
          <h2 className="text-3xl md:text-5xl font-bold mt-4">
            Por que escolher <span className="gradient-text">Ad4You Pages.</span>
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto">
          {items.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ delay: 0.15 * i }}
              className="glass-card rounded-2xl p-6 text-center group hover:border-primary/30 transition-colors"
            >
              <div className="w-14 h-14 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto mb-4 group-hover:bg-primary/20 transition-colors">
                <item.icon className="w-7 h-7 text-primary" />
              </div>
              <h3 className="font-bold mb-2">{item.title}</h3>
              <p className="text-sm text-muted-foreground">{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DifferentialsSection;
